import debounce from 'lodash.debounce'
import throttle from 'lodash.throttle'
import * as React from 'react'

// eslint-disable-next-line @typescript-eslint/ban-types
export const useDebouncedCallback = <Callback extends Function>(
  callback: Callback,
  dependencies: React.DependencyList,
  wait = 500
): Callback => {
  const memoDeps = React.useMemo(
    () => [wait, ...dependencies],
    [dependencies, wait]
  )

  // @ts-ignore
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return React.useCallback(debounce(callback, wait), memoDeps)
}

// eslint-disable-next-line @typescript-eslint/ban-types
export const useThrottledCallback = <Callback extends Function>(
  callback: Callback,
  dependencies: React.DependencyList,
  wait = 500
): Callback => {
  const memoDeps = React.useMemo(
    () => [wait, ...dependencies],
    [dependencies, wait]
  )

  // @ts-ignore
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return React.useCallback(throttle(callback, wait), memoDeps)
}
